"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _reactI18next = require("react-i18next");

var _GenericFormElement = _interopRequireDefault(require("../GenericFormElement"));

var _Input = _interopRequireDefault(require("../Select/Input"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];

  if (null != _i) {
    var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;

    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DateSelect = function DateSelect(props) {
  var title = props.title,
      fieldName = props.fieldName,
      yearMin = props.yearMin,
      yearMax = props.yearMax,
      hideYear = props.hideYear,
      fixedYear = props.fixedYear,
      required = props.required,
      displayRequiredIndicator = props.displayRequiredIndicator,
      requiredError = props.requiredError,
      notValidError = props.notValidError,
      dayPlaceholder = props.dayPlaceholder,
      monthPlaceholder = props.monthPlaceholder,
      yearPlaceholder = props.yearPlaceholder;

  var _useFormikContext = (0, _formik.useFormikContext)(),
      setFieldValue = _useFormikContext.setFieldValue,
      isSubmitting = _useFormikContext.isSubmitting,
      values = _useFormikContext.values;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t; // Set all states for the date.


  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      day = _useState2[0],
      setDay = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      month = _useState4[0],
      setMonth = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      year = _useState6[0],
      setYear = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      showError = _useState8[0],
      setShowError = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      error = _useState10[0],
      setError = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = _slicedToArray(_useState11, 2),
      dateNotValid = _useState12[0],
      setDateNotValid = _useState12[1]; // List all day options


  var dayOptions = (0, _react.useCallback)(function (placeholder) {
    var options = [];

    if (placeholder) {
      options.push({
        value: placeholder,
        label: placeholder
      });
    }

    for (var index = 1; index <= 31; index++) {
      options.push({
        value: index,
        label: index
      });
    }

    return options;
  }, []); // List all month options

  var monthOptions = (0, _react.useCallback)(function () {
    var months = [t('dateselect.months.jan', 'Januari'), t('dateselect.months.feb', 'Februari'), t('dateselect.months.mar', 'Maart'), t('dateselect.months.apr', 'April'), t('dateselect.months.may', 'Mei'), t('dateselect.months.jun', 'Juni'), t('dateselect.months.jul', 'Juli'), t('dateselect.months.aug', 'Augustus'), t('dateselect.months.sep', 'September'), t('dateselect.months.oct', 'Oktober'), t('dateselect.months.nov', 'November'), t('dateselect.months.dec', 'December')];
    return months.map(function (e, i) {
      return {
        value: i + 1,
        label: e
      };
    });
  }, []); // List all options for possible years from the yearMin and yearMax variables.

  var yearOptions = (0, _react.useCallback)(function () {
    var options = [];

    for (var index = yearMin; index <= yearMax; index++) {
      options.push({
        value: index,
        label: index
      });
    }

    return options;
  }, [yearMin, yearMax]); // Check if all fields are filled

  (0, _react.useEffect)(function () {
    if (isSubmitting) {
      if (required && !values[fieldName]) {
        !dateNotValid && setError(requiredError);
        setShowError(true);
      }
    }
  }, [isSubmitting]); // Validation and setting either an error or the FieldValue

  (0, _react.useEffect)(function () {
    hideYear && setYear(fixedYear || new Date().getFullYear()); // All options are filled, start validation

    if (day && month && year) {
      var date = new Date("".concat(year, "-").concat(month, "-").concat(day));

      if (!( // Take note of the exclamation mark
      date.getDate() === day && date.getMonth() + 1 === month && date.getFullYear() === year)) {
        // Depending on your browser, an invalid date overflows to the next month.
        // For example, the 30th of Februari can become the 2nd of March.
        // If that is the case, you still get a valid Date object, but it's not what
        // the user filled in.
        setError(notValidError);
        setShowError(true);
        setDateNotValid(true);
        setFieldValue('dateSelect', '');
        return;
      } // The Date is valid, so we hide previous errors and set the FieldValue


      setShowError(false);
      setDateNotValid(false);
      setFieldValue('dateSelect', date);
      return;
    } // In case a Date was selected and set as FieldValue, but the user decides
    // to change the date, we want to hide previous errors and clear the FieldValue
    // so that validation - and also the useEffect on isSubmitting - can do it's job.


    setShowError(false);
    setDateNotValid(false);
    setFieldValue('dateSelect', '');
  }, [day, month, year]);
  return /*#__PURE__*/_react.default.createElement(_GenericFormElement.default, {
    className: "DateSelect",
    title: title,
    required: required,
    displayRequiredIndicator: displayRequiredIndicator,
    error: error,
    touched: showError
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    id: "".concat(fieldName, "day"),
    fieldName: "".concat(fieldName, "day"),
    options: dayOptions(),
    value: day,
    placeholder: dayPlaceholder,
    onChange: function onChange(day) {
      return setDay(day);
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    id: "".concat(fieldName, "month"),
    fieldName: "".concat(fieldName, "month"),
    options: monthOptions(),
    value: month,
    placeholder: monthPlaceholder,
    onChange: function onChange(month) {
      return setMonth(month);
    }
  }), !hideYear && /*#__PURE__*/_react.default.createElement(_Input.default, {
    id: "".concat(fieldName, "year"),
    fieldName: "".concat(fieldName, "year"),
    options: yearOptions(),
    value: year,
    placeholder: yearPlaceholder,
    onChange: function onChange(year) {
      return setYear(year);
    }
  }));
};

DateSelect.defaultProps = {
  title: 'Kies een datum',
  fieldName: 'dateSelect',
  yearMin: 1970,
  yearMax: 2042,
  hideYear: false,
  requiredError: 'Waarde mag niet leeg zijn',
  notValidError: 'Ongeldige datum',
  dayPlaceholder: 'Dag',
  monthPlaceholder: 'Maand',
  yearPlaceholder: 'Jaar'
};
var _default = DateSelect;
exports.default = _default;